/**
 * Traduções públicas (PT / EN / FR).
 * Chaves em dot notation - useLanguage().t('nav.home')
 */

import { aboutPageClassicBundles } from './aboutPageClassic'
import { pageExtrasPt, pageExtrasEn, pageExtrasFr } from './pageExtras'

const pt = {
  lang: { pt: 'PT', en: 'EN', fr: 'FR', switch: 'Idioma' },
  nav: {
    home: 'Início',
    about: 'Sobre Nós',
    services: 'Serviços',
    recruitment: 'Carreira',
    news: 'Notícias',
    contact: 'Contactar',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    menuLabel: 'Menu',
  },
  footer: {
    tagline:
      'Transformamos desafios em oportunidades através de soluções inovadoras e expertise especializada.',
    taglineLine1: 'Transformamos desafios em',
    taglineLine2: 'oportunidades através de soluções',
    taglineLine3: 'inovadoras e expertise especializada.',
    quickTitle: 'Links rápidos',
    servicesTitle: 'Serviços',
    contactsTitle: 'Contactos',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Serviço',
    copyrightLine1: '© {{year}} SOSVOR · BONGO SOLUÇÕES-SERVIÇOS (SU) LDA.',
    copyrightLine2: 'Todos os direitos reservados.',
    developedBy: 'Powered by SOSVOR',
    svc1: 'Engenharia Civil',
    svc2: 'Tecnologia',
    svc7: 'Cibersegurança',
    svc8: 'Gestão de Processos',
    svc9: 'Aplicações de Gestão',
    svc3: 'Design & Marketing',
    svc4: 'Segurança Eletrônica',
    svc5: 'Turismo',
    svc6: 'Imobiliário',
    newsletterTitle: 'Newsletter',
    newsletterLead: 'Inscreva-se para receber novidades da SOSVOR.',
    newsletterPlaceholder: 'Seu e-mail',
    newsletterSubmit: 'Inscrever',
    newsletterSubmitting: 'A inscrever…',
    newsletterSuccess: 'Inscrição confirmada! Verifique o seu email.',
    newsletterSuccessTitle: 'Obrigado pela sua inscrição!',
    newsletterSuccessMessage: 'A sua subscrição foi registada. Em breve receberá novidades personalizadas da SOSVOR.',
    newsletterModalTitle: 'Quase lá!',
    newsletterModalLead: 'Para personalizar os nossos emails, indique como prefere ser tratado(a).',
    newsletterNameLabel: 'Como gostaria de ser chamado(a)?',
    newsletterNamePlaceholder: 'O seu nome',
    newsletterGenderLabel: 'Sexo',
    newsletterGenderMale: 'Masculino',
    newsletterGenderFemale: 'Feminino',
    newsletterModalSubmit: 'Confirmar inscrição',
    newsletterAlreadyTitle: 'Email cadastrado',
    newsletterAlready: 'Este email já se encontra cadastrado na nossa newsletter.',
    newsletterError: 'Não foi possível concluir a inscrição. Tente novamente.',
    newsletterSubject: 'Inscrição Newsletter SOSVOR',
    newsletterBody: 'Olá, desejo inscrever-me na newsletter com o e-mail: {{email}}',
  },
  notfound: {
    title: 'Página não encontrada',
    body: 'A página que você está procurando não existe.',
    cta: 'Voltar ao Início',
  },
  hero: {
    slides: [
      {
        eyebrow: 'Engenharia · Tecnologia · Inovação',
        titleBefore: 'Transformamos desafios complexos em soluções inteligentes e ',
        titleHighlight: 'oportunidades',
        titleAfter: ' de crescimento sustentável',
        lead:
          'Combinamos conhecimento técnico, inovação e experiência para desenvolver projetos que impulsionam empresas, organizações e comunidades rumo a um futuro mais eficiente e competitivo.',
      },
      {
        eyebrow: 'Compromisso · Excelência · Profissionalismo',
        titleBefore: 'Uma equipa multidisciplinar totalmente dedicada a entregar resultados que fazem a ',
        titleHighlight: 'diferença',
        titleAfter: '',
        lead:
          'Trabalhamos com paixão, rigor e responsabilidade, oferecendo acompanhamento próximo e soluções personalizadas para garantir o sucesso de cada projeto que nos é confiado.',
      },
      {
        eyebrow: 'Transformação Digital · Criatividade · Desenvolvimento',
        titleBefore: 'Integramos tecnologia, engenharia e ',
        titleHighlight: 'estratégia',
        titleAfter: ' para criar soluções adaptadas às exigências do mercado moderno',
        lead:
          'Através de uma abordagem inovadora e orientada para resultados, ajudamos os nossos clientes a superar desafios, otimizar processos e alcançar novos níveis de desempenho.',
      },
      {
        eyebrow: 'Confiança · Sustentabilidade · Crescimento',
        titleBefore: 'Construímos relações duradouras baseadas na qualidade dos nossos serviços e na ',
        titleHighlight: 'satisfação',
        titleAfter: ' dos nossos clientes',
        lead:
          'Acreditamos que cada projeto representa uma oportunidade para gerar impacto positivo, criar valor sustentável e contribuir para o crescimento das organizações que confiam em nós.',
      },
    ],
    ctaServices: 'Nossos Serviços',
    ctaContact: 'Contacte-nos',
    carouselNav: 'Destaques da página inicial',
    stat1: 'Projetos Entregues',
    stat2: 'Satisfação do Cliente',
    stat3: 'Suporte Técnico',
    slideAlt1: 'Engenheiro com plantas junto a edifício moderno',
    slideAlt2: 'Equipa multidisciplinar em colaboração profissional',
    slideAlt3: 'Técnico em data center — transformação digital',
    slideAlt4: 'Estratégia corporativa e crescimento sustentável',
  },
  aboutSection: {
    label: 'Quem somos',
    lead:
      'Combinamos expertise técnica e visão estratégica para transformar ideias em resultados concretos, sempre com compromisso com a sustentabilidade.',
    cta: 'Conhecer a SOSVOR',
    mTitle: 'Missão',
    mBody:
      'Oferecer soluções inovadoras e sustentáveis nas áreas de engenharia, tecnologia e serviços, promovendo desenvolvimento, eficiência e valor para os clientes e para a sociedade.',
    vTitle: 'Visão',
    vBody:
      'Ser reconhecida como referência em soluções integradas e sustentáveis, liderando projetos transformadores que elevem padrões de qualidade, inovação e responsabilidade social.',
    valTitle: 'Valores',
    valBody:
      'Inovação, sustentabilidade, ética, comprometimento e excelência operacional em cada projeto.',
  },
  servicesHome: {
    eyebrow: 'O que fazemos',
    h2a: 'Soluções Completas para ',
    h2b: 'Seu Negócio',
    intro:
      'Oferecemos uma gama completa de serviços tecnológicos para impulsionar o crescimento e a inovação da sua empresa.',
    linkAll: 'Ver todos os serviços',
    imgMainAlt: 'Soluções tecnológicas, qualidade e segurança digital',
    imgTeamAlt: 'Equipa técnica em datacenter',
    processTitle: 'Nosso Processo de Trabalho',
    processTitlePrefix: 'Nosso Processo de ',
    processTitleHighlight: 'Trabalho',
    processTitleRest: '',
    processIntro: 'Seguimos uma metodologia comprovada para garantir o sucesso dos seus projetos.',
    p1t: 'Análise',
    p1d: 'Entendemos suas necessidades e objetivos de negócio.',
    p2t: 'Planejamento',
    p2d: 'Criamos uma estratégia personalizada para seu projeto.',
    p3t: 'Desenvolvimento',
    p3d: 'Executamos a solução com metodologias ágeis.',
    p4t: 'Entrega',
    p4d: 'Implementamos e oferecemos suporte contínuo.',
    ctaEyebrow: 'Próximo passo',
    ctaTitle: 'Pronto para começar seu projeto?',
    ctaTitlePrefix: 'Pronto para começar ',
    ctaTitleHighlight: 'seu projeto',
    ctaTitleRest: '?',
    ctaBody:
      'Entre em contato conosco e descubra como podemos ajudar sua empresa a alcançar seus objetivos tecnológicos.',
    ctaQuote: 'Solicitar Orçamento',
    ctaAll: 'Ver Todos os Serviços',
    ctaImgAlt: 'Equipa comercial e de apoio ao cliente disponível para o seu projeto',
    tagline: {
      'engenharia-civil': 'Construindo o futuro com sustentabilidade e inovação',
      tecnologia: 'Transformamos desafios em soluções digitais inteligentes',
      ciberseguranca: 'Protegemos activos digitais com governança, SOC e defesa 24/7',
      'gestao-processos': 'Processamos crescimento, simplificamos gestão e dominamos eficiência',
      'aplicacoes-gestao': 'Desenvolvemos, integramos e modernizamos aplicações de gestão modulares',
      'design-marketing': 'Criamos experiências visuais que fortalecem marcas',
      'seguranca-eletronica': 'Protegendo pessoas, patrimônios e negócios 24 horas por dia',
      turismo: 'Conectamos destinos, oportunidades e experiências únicas',
      consultoria: 'Capacitando profissionais e impulsionando negócios',
      imobiliario: 'Transformamos imóveis em oportunidades de investimento e crescimento',
    },
    mock: {
      'desenvolvimento-software': {
        title: 'Desenvolvimento de Software',
        desc: 'Criamos soluções de software personalizadas para atender às necessidades específicas do seu negócio, desde aplicações web até sistemas empresariais complexos.',
      },
      'consultoria-ti': {
        title: 'Consultoria em TI',
        desc: 'Oferecemos consultoria estratégica para otimizar seus processos de TI, reduzir custos e aumentar a eficiência operacional da sua empresa.',
      },
      'suporte-tecnico': {
        title: 'Suporte Técnico',
        desc: 'Garantimos o funcionamento contínuo dos seus sistemas com suporte técnico especializado 24/7, minimizando interrupções nos seus negócios.',
      },
      'transformacao-digital': {
        title: 'Transformação Digital',
        desc: 'Aceleramos a transformação digital da sua empresa com tecnologias inovadoras, automação de processos e soluções inteligentes.',
      },
    },
  },
  partnersHome: {
    eyebrow: 'Parceiros',
    title: 'Parcerias de confiança',
    titlePrefix: 'Parcerias de ',
    titleHighlight: 'confiança',
    intro:
      'Colaboramos com marcas líderes em cibersegurança e tecnologia para oferecer soluções certificadas, fiáveis e alinhadas com as melhores práticas do mercado.',
    bitdefenderBronze: 'Bitdefender Bronze Partner',
    bitdefenderCertified: 'Bitdefender Certified Partner',
    bitdefender: 'Bitdefender',
    security: 'Segurança & Proteção Digital',
  },
  newsHome: {
    eyebrow: 'Notícias',
    h2a: 'Fique por Dentro ',
    h2b: 'das Novidades',
    intro:
      'Acompanhe as últimas tendências em tecnologia, insights do mercado e novidades da nossa empresa.',
    readMore: 'Ler mais',
    viewAll: 'Ver Todas as Notícias',
    prev: 'Notícia anterior',
    next: 'Próxima notícia',
    goTo: 'Ir para notícia {{n}}',
    empty: 'Nenhuma notícia disponível no momento.',
    minRead: 'min de leitura',
    mock1: {
      title: 'Lançamento da Plataforma Digital de Gestão de Projetos',
      excerpt:
        'Nova ferramenta desenvolvida internamente aumenta eficiência em 35% e permite acompanhamento em tempo real de todos os projetos da empresa.',
      cat: 'Tecnologia',
    },
    mock2: {
      title: 'SOSVOR Expande Operações para o Mercado Internacional',
      excerpt:
        'Empresa anuncia abertura de filiais em Portugal e Brasil, consolidando sua presença global no setor de tecnologia.',
      cat: 'Negócios',
    },
    mock3: {
      title: 'Inovação em Sustentabilidade: Projetos Verdes da SOSVOR',
      excerpt:
        'Conheça as iniciativas sustentáveis que estão transformando a forma como desenvolvemos tecnologia responsável.',
      cat: 'Sustentabilidade',
    },
  },
  contactPage: {
    heroTitle: 'Entre em Contato',
    heroLead: 'Estamos aqui para ajudar. Entre em contato conosco e responderemos o mais rápido possível.',
    infoTitle: 'Informações de Contato',
    infoLead: 'Nossa equipe está pronta para atendê-lo. Escolha a forma de contato que preferir.',
    email: 'E-mail',
    emailNote: 'Resposta em até 24h',
    phone: 'Telefone',
    phoneNote: 'Seg-Sex, 8h às 17h (Horário de Angola)',
    address: 'Endereço',
    hours: 'Horário',
    hoursVal: 'Segunda a Sexta, 8h às 17h',
    hoursTitle: 'Horário de Atendimento',
    hoursWat: '(Horário de Angola - WAT)',
    formTitle: 'Envie uma mensagem',
    name: 'Nome completo',
    emailPh: 'E-mail',
    phonePh: 'Telefone',
    subject: 'Assunto',
    message: 'Mensagem',
    submit: 'Enviar mensagem',
    sending: 'Enviando...',
  },
  recruitmentPage: {
    loading: 'Carregando vagas...',
    errorTitle: 'Erro ao carregar vagas',
    heroTitle: 'Carreira',
    heroLead: 'Junte-se à nossa equipa e faça parte de projetos desafiantes.',
    whyTitle: 'Porquê trabalhar connosco?',
    apply: 'Candidatar-se',
    details: 'Ver detalhes',
  },
  blogPage: {
    heroTitle: 'Notícias',
    heroLead: 'Acompanhe as novidades da SOSVOR e do setor.',
    catAll: 'Todos',
    catCompany: 'Empresa',
    catProjects: 'Projetos',
    catTech: 'Tecnologia',
    catMarket: 'Mercado',
    readMore: 'Ler mais',
    loading: 'A carregar publicações...',
  },
  servicesPage: {
    heroTitle: 'Áreas de Atuação',
    heroLead:
      'Oferecemos soluções integradas e personalizadas em diversas áreas, combinando expertise técnica e visão estratégica para transformar ideias em resultados concretos.',
    loading: 'Carregando serviços...',
    cta: 'Saber mais',
    editorialCtaDetail: 'Ver detalhes',
    editorialCtaQuote: 'Pedir orçamento',
    fallback: {
      'engenharia-civil': {
        name: 'Engenharia Civil e Infraestruturas Sustentáveis',
        desc: 'Projetos de infraestrutura sustentável e engenharia civil',
      },
      tecnologia: {
        name: 'Tecnologia e Transformação Digital',
        desc: 'Soluções tecnológicas e transformação digital',
      },
      ciberseguranca: {
        name: 'Segurança da Informação e Cibersegurança',
        desc: 'Governança de SI, Blue/Red/Purple Team, SOC, MSSP, continuidade e DLP',
      },
      'gestao-processos': {
        name: 'Gestão Inteligente de Processos',
        desc: 'Optimização de processos, Gap Analyser, hiperautomação, BPMO e formações',
      },
      'aplicacoes-gestao': {
        name: 'Aplicações de Gestão',
        desc: 'Desenvolvimento, integração e modernização de sistemas de backoffice modulares',
      },
      'design-marketing': {
        name: 'Design, Marketing e Audiovisual',
        desc: 'Design, marketing e produção audiovisual',
      },
      'seguranca-eletronica': {
        name: 'Segurança Eletrônica',
        desc: 'Sistemas de segurança eletrônica',
      },
      turismo: {
        name: 'Viagens e Turismo Inteligente',
        desc: 'Serviços de turismo inteligente',
      },
      consultoria: {
        name: 'Comércio Geral e Formação Técnica',
        desc: 'Formação técnica e consultoria',
      },
      imobiliario: {
        name: 'Comercialização imobiliária e serviços imobiliários',
        desc: 'Compra, venda, arrendamento, gestão e marketing de imóveis com tecnologia e transparência',
      },
    },
  },
  serviceDetailUI: {
    introEyebrow: 'Introdução',
    sectionH2: 'Soluções completas para {{topic}}',
    notFoundTitle: 'Serviço não encontrado',
    notFoundBody: 'O serviço solicitado não existe.',
    backToServices: 'Voltar aos serviços',
  },
  blogPageExtra: {
    heroTitle: 'Notícias & Blog',
    heroLead:
      'Fique por dentro das últimas novidades, projetos e tendências do mundo da tecnologia e infraestrutura.',
    featured: 'Destaque',
    featuredArticle: 'Artigo em Destaque',
    minRead: 'min de leitura',
  },
  recruitmentPageExtra: {
    joinTitle: 'Junte-se à Equipe SOSVOR',
    joinLead:
      'Faça parte de uma equipe inovadora e descubra oportunidades de crescimento profissional em um ambiente dinâmico e desafiador.',
    viewJobs: 'Ver Vagas Disponíveis',
    spontaneous: 'Candidatura Espontânea',
    whyH2: 'Por que trabalhar na SOSVOR?',
    vacanciesH2: 'Vagas Disponíveis',
    retry: 'Tentar novamente',
    wj1t: 'Ambiente Inovador',
    wj1d: 'Trabalhe em uma empresa que valoriza a inovação e está sempre na vanguarda tecnológica.',
    wj2t: 'Crescimento Profissional',
    wj2d: 'Oportunidades de desenvolvimento e crescimento em diferentes áreas de atuação.',
    wj3t: 'Equipe Diversificada',
    wj3d: 'Faça parte de uma equipe multicultural e multidisciplinar.',
    noVacanciesTitle: 'Nenhuma vaga disponível no momento',
    noVacanciesLead: 'Mas você ainda pode enviar sua candidatura espontânea!',
    noVacanciesCta: 'Enviar Candidatura Espontânea',
    noVacanciesFilter: 'Nenhuma vaga encontrada com os filtros selecionados.',
    noVacanciesScroll: 'Role para baixo para enviar a sua candidatura espontânea',
    jobType_FULL_TIME: 'Tempo integral',
    jobType_PART_TIME: 'Meio período',
    jobType_CONTRACT: 'Contrato',
    jobType_INTERNSHIP: 'Estágio',
    jobType_FREELANCE: 'Freelance',
    exp_ENTRY: 'Iniciante',
    exp_JUNIOR: 'Júnior',
    exp_MID: 'Pleno',
    exp_SENIOR: 'Sênior',
    exp_LEAD: 'Líder',
    exp_EXECUTIVE: 'Executivo',
    appsCount: '{{count}} candidatura(s)',
    viewDetails: 'Ver detalhes',
    applyShort: 'Candidatar-se',
    salaryTbd: 'A combinar',
    modalAbout: 'Sobre a vaga',
    modalReq: 'Requisitos',
    modalResp: 'Responsabilidades',
    modalBenefits: 'Benefícios',
    modalAppsLine: '{{count}} candidatura(s) recebida(s)',
    close: 'Fechar',
    applyNow: 'Candidatar-se agora',
    ctaNoVacancyTitle: 'Não encontrou a vaga ideal?',
    ctaNoVacancyLead:
      'Envie seu currículo para nosso banco de talentos e seja o primeiro a saber sobre novas oportunidades que combinem com seu perfil.',
    ctaSendResume: 'Enviar currículo',
    processIntroA: 'Acompanhe o nosso processo de seleção, simples, claro e ',
    processIntroHighlight: 'transparente',
    processStep1Title: 'Envie seu Currículo',
    processStep1Desc: 'Preencha o formulário com suas informações e documentos.',
    processStep2Title: 'Entraremos em Contato',
    processStep2Desc: 'Nossa equipe de RH analisará seu perfil e retornará em caso de compatibilidade.',
    processStep3Title: 'Processo Seletivo',
    processStep3Desc: 'Se houver aderência, você será convidado para avançar no processo.',
  },
  aboutPage: {
    heroBadge: 'Sobre a SOSVOR',
    heroP1: 'Na ',
    heroP2:
      ', transformamos desafios em oportunidades. Somos uma marca da ',
    heroP3:
      ', dedicada a oferecer soluções integradas e personalizadas em Engenharia, Tecnologia e Serviços Inovadores. Combinamos expertise técnica e visão estratégica para transformar ideias em resultados concretos, sempre com compromisso com a sustentabilidade. Nossa atuação é baseada em planejamento, eficiência e métodos bem estruturados.',
    brandTitle: 'Significado da Marca SOSVOR',
    brandIntro: 'Cada letra da sigla SOSVOR representa os valores e princípios que sustentam a identidade da empresa:',
    whyTitle: 'Por que escolher a SOSVOR?',
    whyIntro: 'Na SOSVOR, destacamos os nossos Diferenciais Competitivos, que incluem:',
    stats1: 'Projetos Entregues',
    stats2: 'Satisfação do Cliente',
    stats3: 'Suporte Técnico',
    stats4: 'Anos de Experiência',
    valuesHead: 'Nossos Valores',
    valuesSub: 'Os princípios que guiam nossa atuação e definem nossa cultura organizacional',
    mvMission: 'Missão',
    mvMissionBody:
      'Transformar desafios em oportunidades através de soluções inovadoras e expertise especializada, sempre com compromisso com a sustentabilidade e excelência operacional.',
    mvVision: 'Visão',
    mvVisionBody:
      'Ser reconhecida como referência em soluções integradas de Engenharia, Tecnologia e Serviços Inovadores, contribuindo para um futuro mais sustentável e tecnologicamente avançado.',
    mvValues: 'Valores',
    mvValuesBody:
      'Inovação, Sustentabilidade, Responsabilidade Social, Excelência Operacional, Comprometimento e Ética e Transparência em todas as nossas ações.',
    v1t: 'Inovação',
    v1d: 'Transformar ideias em soluções criativas e eficazes para cada desafio apresentado.',
    v2t: 'Sustentabilidade',
    v2d: 'Promover o equilíbrio entre progresso e respeito ao meio ambiente e ao futuro.',
    v3t: 'Responsabilidade Social',
    v3d: 'Contribuir para o bem-estar da sociedade com práticas éticas e inclusivas.',
    v4t: 'Excelência Operacional',
    v4d: 'Superar expectativas com eficiência e qualidade em tudo que fazemos.',
    v5t: 'Comprometimento',
    v5d: 'Garantir dedicação total aos desafios e às necessidades de nossos clientes.',
    v6t: 'Ética e Transparência',
    v6d: 'Agir com integridade em todas as nossas relações e decisões empresariais.',
  },
  aboutPageClassic: aboutPageClassicBundles.pt,
  ...pageExtrasPt,
}

const en = {
  lang: { pt: 'PT', en: 'EN', fr: 'FR', switch: 'Language' },
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    recruitment: 'Careers',
    news: 'News',
    contact: 'Contact us',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    menuLabel: 'Menu',
  },
  footer: {
    tagline:
      'We turn challenges into opportunities through innovative solutions and specialized expertise.',
    taglineLine1: 'We turn challenges into',
    taglineLine2: 'opportunities through innovative',
    taglineLine3: 'solutions and specialized expertise.',
    quickTitle: 'Quick links',
    servicesTitle: 'Services',
    contactsTitle: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    copyrightLine1: '© {{year}} SOSVOR · BONGO SOLUÇÕES-SERVIÇOS (SU) LDA.',
    copyrightLine2: 'All rights reserved.',
    developedBy: 'Powered by SOSVOR',
    svc1: 'Civil Engineering',
    svc2: 'Technology',
    svc7: 'Cybersecurity',
    svc8: 'Process management',
    svc9: 'Management apps',
    svc3: 'Design & Marketing',
    svc4: 'Electronic Security',
    svc5: 'Tourism',
    svc6: 'Real estate',
    newsletterTitle: 'Newsletter',
    newsletterLead: 'Subscribe to receive SOSVOR updates.',
    newsletterPlaceholder: 'Your email',
    newsletterSubmit: 'Subscribe',
    newsletterSubmitting: 'Subscribing…',
    newsletterSuccess: 'Subscription confirmed! Check your email.',
    newsletterSuccessTitle: 'Thank you for subscribing!',
    newsletterSuccessMessage: 'Your subscription has been registered. You will soon receive personalized updates from SOSVOR.',
    newsletterModalTitle: 'Almost there!',
    newsletterModalLead: 'To personalize our emails, tell us how you would like to be addressed.',
    newsletterNameLabel: 'What would you like us to call you?',
    newsletterNamePlaceholder: 'Your name',
    newsletterGenderLabel: 'Gender',
    newsletterGenderMale: 'Male',
    newsletterGenderFemale: 'Female',
    newsletterModalSubmit: 'Confirm subscription',
    newsletterAlreadyTitle: 'Email already registered',
    newsletterAlready: 'This email is already registered on our newsletter list.',
    newsletterError: 'Could not complete your subscription. Please try again.',
    newsletterSubject: 'SOSVOR Newsletter subscription',
    newsletterBody: 'Hello, I would like to subscribe to the newsletter with email: {{email}}',
  },
  notfound: {
    title: 'Page not found',
    body: 'The page you are looking for does not exist.',
    cta: 'Back to Home',
  },
  hero: {
    slides: [
      {
        eyebrow: 'Engineering · Technology · Innovation',
        titleBefore: 'We turn complex challenges into smart solutions and sustainable growth ',
        titleHighlight: 'opportunities',
        titleAfter: '',
        lead:
          'We combine technical knowledge, innovation and experience to deliver projects that drive companies, organisations and communities toward a more efficient and competitive future.',
      },
      {
        eyebrow: 'Commitment · Excellence · Professionalism',
        titleBefore: 'A multidisciplinary team fully dedicated to delivering results that make a ',
        titleHighlight: 'difference',
        titleAfter: '',
        lead:
          'We work with passion, rigour and responsibility, offering close support and tailored solutions to ensure the success of every project entrusted to us.',
      },
      {
        eyebrow: 'Digital Transformation · Creativity · Development',
        titleBefore: 'We integrate technology, engineering and ',
        titleHighlight: 'strategy',
        titleAfter: ' to build solutions fit for the modern market',
        lead:
          'Through an innovative, results-driven approach, we help clients overcome challenges, optimise processes and reach new levels of performance.',
      },
      {
        eyebrow: 'Trust · Sustainability · Growth',
        titleBefore: 'We build lasting relationships based on service quality and client ',
        titleHighlight: 'satisfaction',
        titleAfter: '',
        lead:
          'We believe every project is an opportunity to create positive impact, sustainable value and growth for the organisations that trust us.',
      },
    ],
    ctaServices: 'Our Services',
    ctaContact: 'Contact us',
    carouselNav: 'Homepage highlights',
    stat1: 'Projects Delivered',
    stat2: 'Client Satisfaction',
    stat3: 'Technical Support',
    slideAlt1: 'Engineer with blueprints near a modern building',
    slideAlt2: 'Multidisciplinary team in professional collaboration',
    slideAlt3: 'Technician in data center — digital transformation',
    slideAlt4: 'Corporate strategy and sustainable growth',
  },
  aboutSection: {
    label: 'Who we are',
    lead:
      'We combine technical expertise and strategic vision to turn ideas into tangible results, always committed to sustainability.',
    cta: 'Discover SOSVOR',
    mTitle: 'Mission',
    mBody:
      'Deliver innovative and sustainable solutions in engineering, technology and services, promoting development, efficiency and value for clients and society.',
    vTitle: 'Vision',
    vBody:
      'To be recognized as a benchmark in integrated, sustainable solutions, leading transformative projects that raise standards of quality, innovation and social responsibility.',
    valTitle: 'Values',
    valBody: 'Innovation, sustainability, ethics, commitment and operational excellence in every project.',
  },
  servicesHome: {
    eyebrow: 'What we do',
    h2a: 'Complete Solutions for ',
    h2b: 'Your Business',
    intro:
      'We offer a full range of technology services to drive your company’s growth and innovation.',
    linkAll: 'View all services',
    imgMainAlt: 'Technology solutions, quality and digital security',
    imgTeamAlt: 'Technical team in a data centre',
    processTitle: 'Our Work Process',
    processTitlePrefix: 'Our ',
    processTitleHighlight: 'Work',
    processTitleRest: ' Process',
    processIntro: 'We follow a proven methodology to ensure the success of your projects.',
    p1t: 'Analysis',
    p1d: 'We understand your needs and business goals.',
    p2t: 'Planning',
    p2d: 'We create a tailored strategy for your project.',
    p3t: 'Development',
    p3d: 'We execute the solution using agile methodologies.',
    p4t: 'Delivery',
    p4d: 'We implement and provide ongoing support.',
    ctaEyebrow: 'Next step',
    ctaTitle: 'Ready to start your project?',
    ctaTitlePrefix: 'Ready to start ',
    ctaTitleHighlight: 'your project',
    ctaTitleRest: '?',
    ctaBody:
      'Get in touch and find out how we can help your company achieve its technology goals.',
    ctaQuote: 'Request a quote',
    ctaAll: 'View all services',
    ctaImgAlt: 'Commercial and customer support team ready for your project',
    tagline: {
      'engenharia-civil': 'Building the future with sustainability and innovation',
      tecnologia: 'Turning challenges into smart digital solutions',
      ciberseguranca: 'Protecting digital assets with governance, SOC and 24/7 defense',
      'gestao-processos': 'Process growth, simplify management and master efficiency',
      'aplicacoes-gestao': 'Develop, integrate and modernise modular management applications',
      'design-marketing': 'Creating visual experiences that strengthen brands',
      'seguranca-eletronica': 'Protecting people, assets and businesses around the clock',
      turismo: 'Connecting destinations, opportunities and unique experiences',
      consultoria: 'Empowering professionals and driving business growth',
      imobiliario: 'Turning property into investment and growth opportunities',
    },
    mock: {
      'desenvolvimento-software': {
        title: 'Software Development',
        desc: 'We build custom software from web applications to complex enterprise systems.',
      },
      'consultoria-ti': {
        title: 'IT Consulting',
        desc: 'Strategic consulting to optimize IT processes, reduce costs and improve efficiency.',
      },
      'suporte-tecnico': {
        title: 'Technical Support',
        desc: '24/7 specialized support to keep your systems running with minimal disruption.',
      },
      'transformacao-digital': {
        title: 'Digital Transformation',
        desc: 'We accelerate digital transformation with innovative tech, automation and smart solutions.',
      },
    },
  },
  partnersHome: {
    eyebrow: 'Partners',
    title: 'Trusted partnerships',
    titlePrefix: 'Trusted ',
    titleHighlight: 'partnerships',
    intro:
      'We work with leading cybersecurity and technology brands to deliver certified, reliable solutions aligned with industry best practices.',
    bitdefenderBronze: 'Bitdefender Bronze Partner',
    bitdefenderCertified: 'Bitdefender Certified Partner',
    bitdefender: 'Bitdefender',
    security: 'Security & Digital Protection',
  },
  newsHome: {
    eyebrow: 'News',
    h2a: 'Stay on Top of ',
    h2b: 'What’s New',
    intro: 'Follow technology trends, market insights and company updates.',
    readMore: 'Read more',
    viewAll: 'View all news',
    prev: 'Previous article',
    next: 'Next article',
    goTo: 'Go to article {{n}}',
    empty: 'No news available at the moment.',
    minRead: 'min read',
    mock1: {
      title: 'Launch of the Digital Project Management Platform',
      excerpt:
        'A new in-house tool boosts efficiency by 35% and enables real-time monitoring of all company projects.',
      cat: 'Technology',
    },
    mock2: {
      title: 'SOSVOR Expands Operations Internationally',
      excerpt:
        'The company announces branches in Portugal and Brazil, strengthening its global presence in technology.',
      cat: 'Business',
    },
    mock3: {
      title: 'Sustainability Innovation: SOSVOR Green Projects',
      excerpt:
        'Discover the sustainable initiatives shaping how we build responsible technology.',
      cat: 'Sustainability',
    },
  },
  contactPage: {
    heroTitle: 'Contact us',
    heroLead: 'We are here to help. Reach out and we will respond as soon as possible.',
    infoTitle: 'Contact information',
    infoLead: 'Our team is ready. Choose the channel you prefer.',
    email: 'Email',
    emailNote: 'Reply within 24h',
    phone: 'Phone',
    phoneNote: 'Mon–Fri, 8am–5pm (Angola time)',
    address: 'Address',
    hours: 'Hours',
    hoursVal: 'Monday to Friday, 8am–5pm',
    hoursTitle: 'Business hours',
    hoursWat: '(Angola time - WAT)',
    formTitle: 'Send a message',
    name: 'Full name',
    emailPh: 'Email',
    phonePh: 'Phone',
    subject: 'Subject',
    message: 'Message',
    submit: 'Send message',
    sending: 'Sending...',
  },
  recruitmentPage: {
    loading: 'Loading jobs...',
    errorTitle: 'Error loading jobs',
    heroTitle: 'Careers',
    heroLead: 'Join our team and work on challenging projects.',
    whyTitle: 'Why work with us?',
    apply: 'Apply',
    details: 'View details',
  },
  blogPage: {
    heroTitle: 'News',
    heroLead: 'Follow SOSVOR and industry updates.',
    catAll: 'All',
    catCompany: 'Company',
    catProjects: 'Projects',
    catTech: 'Technology',
    catMarket: 'Market',
    readMore: 'Read more',
    loading: 'Loading posts...',
  },
  servicesPage: {
    heroTitle: 'Practice areas',
    heroLead:
      'We deliver integrated, tailored solutions across multiple areas, combining technical expertise and strategic vision to turn ideas into concrete results.',
    loading: 'Loading services...',
    cta: 'Learn more',
    editorialCtaDetail: 'View details',
    editorialCtaQuote: 'Request a quote',
    fallback: {
      'engenharia-civil': {
        name: 'Civil engineering & sustainable infrastructure',
        desc: 'Sustainable infrastructure and civil engineering projects',
      },
      tecnologia: {
        name: 'Technology & digital transformation',
        desc: 'Technology solutions and digital transformation',
      },
      ciberseguranca: {
        name: 'Information security & cybersecurity',
        desc: 'Security governance, Blue/Red/Purple Team, SOC, MSSP, continuity and DLP',
      },
      'gestao-processos': {
        name: 'Intelligent process management',
        desc: 'Process optimisation, Gap Analyser, hyperautomation, BPMO and training',
      },
      'aplicacoes-gestao': {
        name: 'Management applications',
        desc: 'Development, integration and modernisation of modular back-office systems',
      },
      'design-marketing': {
        name: 'Design, marketing & audiovisual',
        desc: 'Design, marketing and audiovisual production',
      },
      'seguranca-eletronica': {
        name: 'Electronic security',
        desc: 'Electronic security systems',
      },
      turismo: {
        name: 'Travel & smart tourism',
        desc: 'Smart tourism services',
      },
      consultoria: {
        name: 'General trade & technical training',
        desc: 'Technical training and consulting',
      },
      imobiliario: {
        name: 'Real estate sales & property services',
        desc: 'Buy, sell, let, manage and market properties with technology and transparency',
      },
    },
  },
  serviceDetailUI: {
    introEyebrow: 'Overview',
    sectionH2: 'End-to-end solutions for {{topic}}',
    notFoundTitle: 'Service not found',
    notFoundBody: 'The service you requested does not exist.',
    backToServices: 'Back to services',
  },
  blogPageExtra: {
    heroTitle: 'News & Blog',
    heroLead: 'Stay up to date with news, projects and trends in technology and infrastructure.',
    featured: 'Featured',
    featuredArticle: 'Featured article',
    minRead: 'min read',
  },
  recruitmentPageExtra: {
    joinTitle: 'Join the SOSVOR team',
    joinLead:
      'Be part of an innovative team and grow professionally in a dynamic, challenging environment.',
    viewJobs: 'View open positions',
    spontaneous: 'Spontaneous application',
    whyH2: 'Why work at SOSVOR?',
    vacanciesH2: 'Open positions',
    retry: 'Try again',
    wj1t: 'Innovative environment',
    wj1d: 'Work for a company that values innovation and stays at the forefront of technology.',
    wj2t: 'Professional growth',
    wj2d: 'Development opportunities across different areas.',
    wj3t: 'Diverse team',
    wj3d: 'Join a multicultural, multidisciplinary team.',
    noVacanciesTitle: 'No open positions right now',
    noVacanciesLead: 'You can still send a spontaneous application!',
    noVacanciesCta: 'Send spontaneous application',
    noVacanciesFilter: 'No positions match the selected filters.',
    noVacanciesScroll: 'Scroll down to submit your spontaneous application',
    jobType_FULL_TIME: 'Full-time',
    jobType_PART_TIME: 'Part-time',
    jobType_CONTRACT: 'Contract',
    jobType_INTERNSHIP: 'Internship',
    jobType_FREELANCE: 'Freelance',
    exp_ENTRY: 'Entry',
    exp_JUNIOR: 'Junior',
    exp_MID: 'Mid-level',
    exp_SENIOR: 'Senior',
    exp_LEAD: 'Lead',
    exp_EXECUTIVE: 'Executive',
    appsCount: '{{count}} application(s)',
    viewDetails: 'View details',
    applyShort: 'Apply',
    salaryTbd: 'To be agreed',
    modalAbout: 'About the role',
    modalReq: 'Requirements',
    modalResp: 'Responsibilities',
    modalBenefits: 'Benefits',
    modalAppsLine: '{{count}} application(s) received',
    close: 'Close',
    applyNow: 'Apply now',
    ctaNoVacancyTitle: 'Didn’t find the right role?',
    ctaNoVacancyLead:
      'Send your CV to our talent pool and be the first to hear about new opportunities that match your profile.',
    ctaSendResume: 'Send CV',
    processIntroA: 'Follow our selection process, simple, clear and ',
    processIntroHighlight: 'transparent',
    processStep1Title: 'Send your CV',
    processStep1Desc: 'Complete the form with your information and documents.',
    processStep2Title: 'We will get in touch',
    processStep2Desc: 'Our HR team will review your profile and respond if there is a match.',
    processStep3Title: 'Selection process',
    processStep3Desc: 'If there is a fit, you will be invited to move forward in the process.',
  },
  aboutPage: {
    heroBadge: 'About SOSVOR',
    heroP1: 'At ',
    heroP2:
      ', we turn challenges into opportunities. We are a brand of ',
    heroP3:
      ', dedicated to integrated, tailored solutions in Engineering, Technology and Innovative Services. We combine technical expertise and strategic vision to turn ideas into concrete results, always committed to sustainability. Our work is based on planning, efficiency and sound methods.',
    brandTitle: 'Meaning of the SOSVOR brand',
    brandIntro: 'Each letter in SOSVOR reflects the values and principles behind our identity:',
    whyTitle: 'Why choose SOSVOR?',
    whyIntro: 'We highlight our competitive differentiators, including:',
    stats1: 'Projects delivered',
    stats2: 'Client satisfaction',
    stats3: 'Technical support',
    stats4: 'Years of experience',
    valuesHead: 'Our values',
    valuesSub: 'The principles that guide us and shape our culture',
    mvMission: 'Mission',
    mvMissionBody:
      'Turn challenges into opportunities through innovative solutions and specialized expertise, with a commitment to sustainability and operational excellence.',
    mvVision: 'Vision',
    mvVisionBody:
      'To be a reference in integrated Engineering, Technology and Innovative Services, contributing to a more sustainable and technologically advanced future.',
    mvValues: 'Values',
    mvValuesBody:
      'Innovation, sustainability, social responsibility, operational excellence, commitment, ethics and transparency in everything we do.',
    v1t: 'Innovation',
    v1d: 'Turn ideas into creative, effective solutions for every challenge.',
    v2t: 'Sustainability',
    v2d: 'Balance progress with respect for the environment and the future.',
    v3t: 'Social responsibility',
    v3d: 'Contribute to society’s well-being through ethical, inclusive practices.',
    v4t: 'Operational excellence',
    v4d: 'Exceed expectations with efficiency and quality in everything we do.',
    v5t: 'Commitment',
    v5d: 'Dedicated to our clients’ challenges and needs.',
    v6t: 'Ethics and transparency',
    v6d: 'Act with integrity in all relationships and business decisions.',
  },
  aboutPageClassic: aboutPageClassicBundles.en,
  ...pageExtrasEn,
}

const fr = {
  lang: { pt: 'PT', en: 'EN', fr: 'FR', switch: 'Langue' },
  nav: {
    home: 'Accueil',
    about: 'À propos',
    services: 'Services',
    recruitment: 'Carrière',
    news: 'Actualités',
    contact: 'Nous contacter',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    menuLabel: 'Menu',
  },
  footer: {
    tagline:
      'Nous transformons les défis en opportunités grâce à des solutions innovantes et à une expertise pointue.',
    taglineLine1: 'Nous transformons les défis en',
    taglineLine2: 'opportunités grâce à des solutions',
    taglineLine3: 'innovantes et à une expertise pointue.',
    quickTitle: 'Liens rapides',
    servicesTitle: 'Services',
    contactsTitle: 'Contacts',
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
    copyrightLine1: '© {{year}} SOSVOR · BONGO SOLUÇÕES-SERVIÇOS (SU) LDA.',
    copyrightLine2: 'Tous droits réservés.',
    developedBy: 'Powered by SOSVOR',
    svc1: 'Génie civil',
    svc2: 'Technologie',
    svc7: 'Cybersécurité',
    svc8: 'Gestion des processus',
    svc9: 'Applications de gestion',
    svc3: 'Design & marketing',
    svc4: 'Sécurité électronique',
    svc5: 'Tourisme',
    svc6: 'Immobilier',
    newsletterTitle: 'Newsletter',
    newsletterLead: 'Inscrivez-vous pour recevoir les actualités SOSVOR.',
    newsletterPlaceholder: 'Votre e-mail',
    newsletterSubmit: "S'inscrire",
    newsletterSubmitting: 'Inscription…',
    newsletterSuccess: 'Inscription confirmée ! Vérifiez votre e-mail.',
    newsletterSuccessTitle: 'Merci pour votre inscription !',
    newsletterSuccessMessage: 'Votre inscription a été enregistrée. Vous recevrez bientôt des actualités personnalisées de SOSVOR.',
    newsletterModalTitle: 'Presque terminé !',
    newsletterModalLead: 'Pour personnaliser nos e-mails, indiquez comment vous souhaitez être appelé(e).',
    newsletterNameLabel: 'Comment souhaitez-vous être appelé(e) ?',
    newsletterNamePlaceholder: 'Votre prénom',
    newsletterGenderLabel: 'Sexe',
    newsletterGenderMale: 'Masculin',
    newsletterGenderFemale: 'Féminin',
    newsletterModalSubmit: "Confirmer l'inscription",
    newsletterAlreadyTitle: 'E-mail déjà inscrit',
    newsletterAlready: 'Cet e-mail est déjà inscrit à notre newsletter.',
    newsletterError: "Impossible de finaliser l'inscription. Réessayez.",
    newsletterSubject: 'Inscription newsletter SOSVOR',
    newsletterBody: "Bonjour, je souhaite m'inscrire à la newsletter avec l'e-mail : {{email}}",
  },
  notfound: {
    title: 'Page introuvable',
    body: 'La page que vous recherchez n’existe pas.',
    cta: "Retour à l'accueil",
  },
  hero: {
    slides: [
      {
        eyebrow: 'Ingénierie · Technologie · Innovation',
        titleBefore: 'Nous transformons les défis complexes en solutions intelligentes et en ',
        titleHighlight: 'opportunités',
        titleAfter: ' de croissance durable',
        lead:
          'Nous combinons savoir technique, innovation et expérience pour développer des projets qui propulsent entreprises, organisations et communautés vers un avenir plus efficace et compétitif.',
      },
      {
        eyebrow: 'Engagement · Excellence · Professionnalisme',
        titleBefore: 'Une équipe pluridisciplinaire entièrement dédiée à des résultats qui font la ',
        titleHighlight: 'différence',
        titleAfter: '',
        lead:
          'Nous travaillons avec passion, rigueur et responsabilité, en offrant un accompagnement proche et des solutions sur mesure pour garantir le succès de chaque projet confié.',
      },
      {
        eyebrow: 'Transformation numérique · Créativité · Développement',
        titleBefore: 'Nous intégrons technologie, ingénierie et ',
        titleHighlight: 'stratégie',
        titleAfter: ' pour créer des solutions adaptées au marché moderne',
        lead:
          'Par une approche innovante et orientée résultats, nous aidons nos clients à surmonter les défis, optimiser les processus et atteindre de nouveaux niveaux de performance.',
      },
      {
        eyebrow: 'Confiance · Durabilité · Croissance',
        titleBefore: 'Nous construisons des relations durables fondées sur la qualité de nos services et la ',
        titleHighlight: 'satisfaction',
        titleAfter: ' de nos clients',
        lead:
          'Chaque projet est pour nous une opportunité de générer un impact positif, créer une valeur durable et contribuer à la croissance des organisations qui nous font confiance.',
      },
    ],
    ctaServices: 'Nos services',
    ctaContact: 'Nous contacter',
    carouselNav: 'Points forts de la page d’accueil',
    stat1: 'Projets livrés',
    stat2: 'Satisfaction client',
    stat3: 'Support technique',
    slideAlt1: 'Ingénieur avec plans près d’un bâtiment moderne',
    slideAlt2: 'Équipe pluridisciplinaire en collaboration professionnelle',
    slideAlt3: 'Technicien en data center — transformation numérique',
    slideAlt4: 'Stratégie corporate et croissance durable',
  },
  aboutSection: {
    label: 'Qui sommes-nous',
    lead:
      'Nous combinons expertise technique et vision stratégique pour transformer les idées en résultats concrets, toujours engagés pour la durabilité.',
    cta: 'Découvrir SOSVOR',
    mTitle: 'Mission',
    mBody:
      'Offrir des solutions innovantes et durables en ingénierie, technologie et services, en favorisant le développement, l’efficacité et la valeur pour les clients et la société.',
    vTitle: 'Vision',
    vBody:
      'Être une référence en solutions intégrées et durables, en menant des projets transformateurs qui élèvent la qualité, l’innovation et la responsabilité sociale.',
    valTitle: 'Valeurs',
    valBody: 'Innovation, durabilité, éthique, engagement et excellence opérationnelle à chaque projet.',
  },
  servicesHome: {
    eyebrow: 'Ce que nous faisons',
    h2a: 'Des solutions complètes pour ',
    h2b: 'votre entreprise',
    intro:
      'Nous offrons une gamme complète de services technologiques pour accélérer la croissance et l’innovation de votre entreprise.',
    linkAll: 'Voir tous les services',
    imgMainAlt: 'Solutions technologiques, qualité et sécurité numérique',
    imgTeamAlt: 'Équipe technique dans un data center',
    processTitle: 'Notre processus de travail',
    processTitlePrefix: 'Notre processus de ',
    processTitleHighlight: 'travail',
    processTitleRest: '',
    processIntro: 'Nous suivons une méthodologie éprouvée pour assurer le succès de vos projets.',
    p1t: 'Analyse',
    p1d: 'Nous comprenons vos besoins et vos objectifs.',
    p2t: 'Planification',
    p2d: 'Nous définissons une stratégie sur mesure.',
    p3t: 'Développement',
    p3d: 'Nous exécutons la solution avec des méthodes agiles.',
    p4t: 'Livraison',
    p4d: 'Nous déployons et assurons un support continu.',
    ctaEyebrow: 'Prochaine étape',
    ctaTitle: 'Prêt à lancer votre projet ?',
    ctaTitlePrefix: 'Prêt à lancer ',
    ctaTitleHighlight: 'votre projet',
    ctaTitleRest: ' ?',
    ctaBody:
      'Contactez-nous pour découvrir comment nous pouvons aider votre entreprise à atteindre ses objectifs technologiques.',
    ctaQuote: 'Demander un devis',
    ctaAll: 'Voir tous les services',
    ctaImgAlt: 'Équipe commerciale et support client prête pour votre projet',
    tagline: {
      'engenharia-civil': 'Construire l’avenir avec durabilité et innovation',
      tecnologia: 'Transformer les défis en solutions numériques intelligentes',
      ciberseguranca: 'Protéger les actifs numériques : gouvernance, SOC et défense 24 h/24',
      'gestao-processos': 'Traiter la croissance, simplifier la gestion et maîtriser l’efficacité',
      'aplicacoes-gestao': 'Développer, intégrer et moderniser des applications de gestion modulaires',
      'design-marketing': 'Créer des expériences visuelles qui renforcent les marques',
      'seguranca-eletronica': 'Protéger les personnes, les biens et les entreprises 24 h/24',
      turismo: 'Relier destinations, opportunités et expériences uniques',
      consultoria: 'Former les professionnels et dynamiser les entreprises',
      imobiliario: 'Transformer l’immobilier en opportunités d’investissement et de croissance',
    },
    mock: {
      'desenvolvimento-software': {
        title: 'Développement logiciel',
        desc: 'Des solutions sur mesure, des applications web aux systèmes d’entreprise complexes.',
      },
      'consultoria-ti': {
        title: 'Conseil en TI',
        desc: 'Conseil stratégique pour optimiser les processus IT, réduire les coûts et gagner en efficacité.',
      },
      'suporte-tecnico': {
        title: 'Support technique',
        desc: 'Support spécialisé 24/7 pour garantir la continuité de vos systèmes.',
      },
      'transformacao-digital': {
        title: 'Transformation numérique',
        desc: 'Accélération de la transformation digitale avec technologies innovantes et automatisation.',
      },
    },
  },
  partnersHome: {
    eyebrow: 'Partenaires',
    title: 'Partenariats de confiance',
    titlePrefix: 'Partenariats de ',
    titleHighlight: 'confiance',
    intro:
      'Nous collaborons avec des marques leaders en cybersécurité et technologie pour offrir des solutions certifiées, fiables et conformes aux meilleures pratiques du marché.',
    bitdefenderBronze: 'Bitdefender Bronze Partner',
    bitdefenderCertified: 'Bitdefender Certified Partner',
    bitdefender: 'Bitdefender',
    security: 'Sécurité & protection numérique',
  },
  newsHome: {
    eyebrow: 'Actualités',
    h2a: 'Restez informé ',
    h2b: 'des nouveautés',
    intro: 'Tendances technologiques, analyses du marché et nouvelles de l’entreprise.',
    readMore: 'Lire la suite',
    viewAll: 'Toutes les actualités',
    prev: 'Article précédent',
    next: 'Article suivant',
    goTo: 'Aller à l’article {{n}}',
    empty: 'Aucune actualité pour le moment.',
    minRead: 'min de lecture',
    mock1: {
      title: 'Lancement de la plateforme numérique de gestion de projets',
      excerpt:
        'Un nouvel outil interne augmente l’efficacité de 35 % et permet un suivi en temps réel de tous les projets.',
      cat: 'Technologie',
    },
    mock2: {
      title: 'SOSVOR étend ses opérations à l’international',
      excerpt:
        'Ouverture de filiales au Portugal et au Brésil pour renforcer la présence mondiale dans la tech.',
      cat: 'Business',
    },
    mock3: {
      title: 'Innovation durable : les projets verts de SOSVOR',
      excerpt:
        'Découvrez les initiatives durables qui façonnent notre approche responsable de la technologie.',
      cat: 'Durabilité',
    },
  },
  contactPage: {
    heroTitle: 'Contactez-nous',
    heroLead: 'Nous sommes là pour vous aider. Écrivez-nous et nous répondrons au plus vite.',
    infoTitle: 'Coordonnées',
    infoLead: 'Notre équipe est prête. Choisissez le canal qui vous convient.',
    email: 'E-mail',
    emailNote: 'Réponse sous 24 h',
    phone: 'Téléphone',
    phoneNote: 'Lun–Ven, 8h–17h (heure Angola)',
    address: 'Adresse',
    hours: 'Horaires',
    hoursVal: 'Du lundi au vendredi, 8h à 17h',
    hoursTitle: 'Heures d’ouverture',
    hoursWat: '(Heure Angola - WAT)',
    formTitle: 'Envoyer un message',
    name: 'Nom complet',
    emailPh: 'E-mail',
    phonePh: 'Téléphone',
    subject: 'Objet',
    message: 'Message',
    submit: 'Envoyer',
    sending: 'Envoi...',
  },
  recruitmentPage: {
    loading: 'Chargement des offres...',
    errorTitle: 'Erreur de chargement',
    heroTitle: 'Carrière',
    heroLead: 'Rejoignez notre équipe et participez à des projets stimulants.',
    whyTitle: 'Pourquoi nous rejoindre ?',
    apply: 'Postuler',
    details: 'Voir les détails',
  },
  blogPage: {
    heroTitle: 'Actualités',
    heroLead: 'Suivez SOSVOR et l’actualité du secteur.',
    catAll: 'Tous',
    catCompany: 'Entreprise',
    catProjects: 'Projets',
    catTech: 'Technologie',
    catMarket: 'Marché',
    readMore: 'Lire la suite',
    loading: 'Chargement des articles...',
  },
  servicesPage: {
    heroTitle: 'Domaines d’intervention',
    heroLead:
      'Des solutions intégrées et sur mesure dans plusieurs domaines, alliant expertise technique et vision stratégique pour concrétiser vos idées.',
    loading: 'Chargement des services...',
    cta: 'En savoir plus',
    editorialCtaDetail: 'Voir le détail',
    editorialCtaQuote: 'Demander un devis',
    fallback: {
      'engenharia-civil': {
        name: 'Génie civil et infrastructures durables',
        desc: 'Projets d’infrastructure durable et de génie civil',
      },
      tecnologia: {
        name: 'Technologie et transformation numérique',
        desc: 'Solutions technologiques et transformation numérique',
      },
      ciberseguranca: {
        name: 'Sécurité de l’information et cybersécurité',
        desc: 'Gouvernance SI, Blue/Red/Purple Team, SOC, MSSP, continuité et DLP',
      },
      'gestao-processos': {
        name: 'Gestion intelligente des processus',
        desc: 'Optimisation des processus, Gap Analyser, hyperautomatisation, BPMO et formations',
      },
      'aplicacoes-gestao': {
        name: 'Applications de gestion',
        desc: 'Développement, intégration et modernisation de systèmes back-office modulaires',
      },
      'design-marketing': {
        name: 'Design, marketing et audiovisuel',
        desc: 'Design, marketing et production audiovisuelle',
      },
      'seguranca-eletronica': {
        name: 'Sécurité électronique',
        desc: 'Systèmes de sécurité électronique',
      },
      turismo: {
        name: 'Voyages et tourisme intelligent',
        desc: 'Services de tourisme intelligent',
      },
      consultoria: {
        name: 'Commerce général et formation technique',
        desc: 'Formation technique et conseil',
      },
      imobiliario: {
        name: 'Commercialisation immobilière et services immobiliers',
        desc: 'Achat, vente, location, gestion et marketing des biens, avec technologie et transparence',
      },
    },
  },
  serviceDetailUI: {
    introEyebrow: 'Introduction',
    sectionH2: 'Solutions complètes pour {{topic}}',
    notFoundTitle: 'Service introuvable',
    notFoundBody: 'Le service demandé n’existe pas.',
    backToServices: 'Retour aux services',
  },
  blogPageExtra: {
    heroTitle: 'Actualités & blog',
    heroLead:
      'Restez informé des dernières nouvelles, projets et tendances en technologie et infrastructure.',
    featured: 'À la une',
    featuredArticle: 'Article à la une',
    minRead: 'min de lecture',
  },
  recruitmentPageExtra: {
    joinTitle: 'Rejoignez l’équipe SOSVOR',
    joinLead:
      'Intégrez une équipe innovante et développez vos compétences dans un environnement dynamique et stimulant.',
    viewJobs: 'Voir les offres',
    spontaneous: 'Candidature spontanée',
    whyH2: 'Pourquoi travailler chez SOSVOR ?',
    vacanciesH2: 'Offres d’emploi',
    retry: 'Réessayer',
    wj1t: 'Environnement innovant',
    wj1d: 'Une entreprise qui valorise l’innovation et reste à la pointe de la technologie.',
    wj2t: 'Évolution professionnelle',
    wj2d: 'Des opportunités de développement dans différents domaines.',
    wj3t: 'Équipe diversifiée',
    wj3d: 'Une équipe multiculturelle et multidisciplinaire.',
    noVacanciesTitle: 'Aucune offre pour le moment',
    noVacanciesLead: 'Vous pouvez tout de même envoyer une candidature spontanée !',
    noVacanciesCta: 'Candidature spontanée',
    noVacanciesFilter: 'Aucune offre ne correspond aux filtres sélectionnés.',
    noVacanciesScroll: 'Faites défiler vers le bas pour envoyer votre candidature spontanée',
    jobType_FULL_TIME: 'Temps plein',
    jobType_PART_TIME: 'Temps partiel',
    jobType_CONTRACT: 'Contrat',
    jobType_INTERNSHIP: 'Stage',
    jobType_FREELANCE: 'Freelance',
    exp_ENTRY: 'Débutant',
    exp_JUNIOR: 'Junior',
    exp_MID: 'Confirmé',
    exp_SENIOR: 'Senior',
    exp_LEAD: 'Lead',
    exp_EXECUTIVE: 'Direction',
    appsCount: '{{count}} candidature(s)',
    viewDetails: 'Voir les détails',
    applyShort: 'Postuler',
    salaryTbd: 'À négocier',
    modalAbout: 'À propos du poste',
    modalReq: 'Exigences',
    modalResp: 'Responsabilités',
    modalBenefits: 'Avantages',
    modalAppsLine: '{{count}} candidature(s) reçue(s)',
    close: 'Fermer',
    applyNow: 'Postuler maintenant',
    ctaNoVacancyTitle: 'Vous n’avez pas trouvé le bon poste ?',
    ctaNoVacancyLead:
      'Envoyez votre CV à notre vivier de talents et soyez informé en priorité des nouvelles opportunités adaptées à votre profil.',
    ctaSendResume: 'Envoyer le CV',
    processIntroA: 'Suivez notre processus de sélection, simple, clair et ',
    processIntroHighlight: 'transparent',
    processStep1Title: 'Envoyez votre CV',
    processStep1Desc: 'Remplissez le formulaire avec vos informations et documents.',
    processStep2Title: 'Nous vous contacterons',
    processStep2Desc: 'Notre équipe RH analysera votre profil et vous répondra en cas de compatibilité.',
    processStep3Title: 'Processus de sélection',
    processStep3Desc: 'En cas d’adéquation, vous serez invité à poursuivre le processus.',
  },
  aboutPage: {
    heroBadge: 'À propos de SOSVOR',
    heroP1: 'Chez ',
    heroP2:
      ', nous transformons les défis en opportunités. Nous sommes une marque de ',
    heroP3:
      ", dédiée à des solutions intégrées et sur mesure en ingénierie, technologie et services innovants. Nous combinons expertise technique et vision stratégique pour concrétiser les idées, avec un engagement constant pour la durabilité. Notre action repose sur la planification, l'efficacité et des méthodes structurées.",
    brandTitle: 'Signification de la marque SOSVOR',
    brandIntro: 'Chaque lettre de SOSVOR reflète les valeurs et principes qui fondent notre identité :',
    whyTitle: 'Pourquoi choisir SOSVOR ?',
    whyIntro: 'Nous mettons en avant nos différenciateurs, notamment :',
    stats1: 'Projets livrés',
    stats2: 'Satisfaction client',
    stats3: 'Support technique',
    stats4: "Années d'expérience",
    valuesHead: 'Nos valeurs',
    valuesSub: 'Les principes qui guident notre action et notre culture',
    mvMission: 'Mission',
    mvMissionBody:
      'Transformer les défis en opportunités grâce à des solutions innovantes et une expertise pointue, avec engagement pour la durabilité et l’excellence opérationnelle.',
    mvVision: 'Vision',
    mvVisionBody:
      'Être une référence en solutions intégrées d’ingénierie, technologie et services innovants, pour un avenir plus durable et technologique.',
    mvValues: 'Valeurs',
    mvValuesBody:
      'Innovation, durabilité, responsabilité sociale, excellence opérationnelle, engagement, éthique et transparence.',
    v1t: 'Innovation',
    v1d: 'Transformer les idées en solutions créatives et efficaces pour chaque défi.',
    v2t: 'Durabilité',
    v2d: 'Promouvoir l’équilibre entre progrès et respect de l’environnement et de l’avenir.',
    v3t: 'Responsabilité sociale',
    v3d: 'Contribuer au bien-être de la société avec des pratiques éthiques et inclusives.',
    v4t: 'Excellence opérationnelle',
    v4d: 'Dépasser les attentes avec efficacité et qualité dans tout ce que nous faisons.',
    v5t: 'Engagement',
    v5d: 'Une dédication totale aux défis et aux besoins de nos clients.',
    v6t: 'Éthique et transparence',
    v6d: 'Agir avec intégrité dans toutes nos relations et décisions.',
  },
  aboutPageClassic: aboutPageClassicBundles.fr,
  ...pageExtrasFr,
}

export const dictionaries = { pt, en, fr }
